import React from 'react'
import { observable, action, toJS, computed, makeObservable, runInAction } from 'mobx'
import api from '../service/api'
import UserStore from "./user.store"
import fileDownload from 'js-file-download'
import NotificationStore from "./notification.store"
import { toast } from 'react-toastify'
import { formatDate } from '../utils/utilities'
const notification = NotificationStore
class RoomStore {

    rooms
    activeRoom
    auditRoom
    streamDetails
    feedback
    loading
    exam
    evaluate
    errors
    constructor () {
        this.rooms = {}
        this.api = api
        this.activeRoom = []
        this.auditRoom = []
        this.streamDetails = { "is_stream": false, "stream_url": null, "stream_session": null, "stream_presenter": false }
        this.feedback = []
        this.loading = false
        this.exam = []
        this.evaluate = []
        this.errors = {}
        makeObservable( this, {
            rooms: observable,
            exam: observable,
            evaluate: observable,
            loading: observable,
            auditRoom: observable,
            streamDetails: observable,
            feedback: observable,
            activeRoom: observable,
            getRooms: computed,
            getExam: computed,
            getSubmission: computed,
            getAuditRoom: computed,
            getStreamDetails: computed,
            getFeedback: computed,
            getActiveRoom: computed,
            fetchRoom: action,
            fetchAuditRoom: action,
            createRoom: action,
            startSession: action,
            fetchViewerAndPresenterRooms: action,
            joinSession: action,
            joinSessionAsModerator: action,
            endSession: action,
            endSessionByAdmin: action,
            getMyActiveSessions: action,
            setStreamDetails: action,
            submitFeedback: action,
            //getSessionClassAttendence:action,
            resetStreamDetails: action,
            getErrors: computed,
        } )
    }

    get getRooms () {
        return toJS( this.rooms )
    }

    get getExam () {
        return toJS( this.exam )
    }

    get getSubmission () {
        return toJS( this.evaluate )
    }

    get getActiveRoom () {
        return toJS( this.activeRoom )
    }

    get getAuditRoom () {
        return toJS( this.auditRoom )
    }

    get getStreamDetails () {
        return toJS( this.streamDetails )
    }

    get getFeedback () {
        return toJS( this.feedback )
    }

    get getErrors () {
        return toJS( this.errors )
    }

    resetStreamDetails = () => {
        this.streamDetails = { "is_stream": false, "stream_url": null, "stream_session": null, "stream_presenter": false }
    }

    setStreamDetails = ( bool, url, session, stream_presenter = false ) => {
        this.streamDetails = { "is_stream": bool, "stream_url": url, "stream_session": session, "stream_presenter": stream_presenter }
    }

    fetchRoom = async ( date ) => {

        try {
            const res = await this.api.getRoom( { startingdate: date, endingdate: date } )
            runInAction( () => {
                this.rooms[date] = res["data"]["data"] ? res["data"]["data"] : []
                this.errors[date] = false
            } )
        } catch ( err ) {
            console.log( err )
            runInAction( () => {
                this.errors[date] = false
            } )
        }

    }

    fetchAuditRoom = async ( data ) => {
        try {
            const res = await this.api.auditSession( data )
            runInAction( () => {
                this.auditRoom = res["data"]["data"]
            } )
        } catch ( err ) {
            console.log( err )
        }
    }

    fetchViewerAndPresenterRooms = async ( date = formatDate( new Date(), { format: "YYYY-MM-DD" } ) ) => {
        try {
            const res = await this.api.getRooms( { date } )
            runInAction( () => {
                this.rooms[date] = res["data"]["data"] ? res["data"]["data"] : []
                this.errors[date] = false
            } )
        } catch ( err ) {
            console.log( err )
            runInAction( () => {
                this.errors[date] = true
            } )
            toast( err?.response?.data?.message || "Failed to fetch your class from timetable." )
        }

    }
    fetchFeedback = async ( payload ) => {
        try {
            const res = await this.api.auditFeedback( payload )
            this.feedback = res["data"]["data"] ? res["data"]["data"] : []
        } catch ( err ) {
            console.log( err )
        }
    }
    createRoom = async ( payload ) => {

        try {
            this.api.createRoom( payload )
            //console.log(res)
            this.fetchRoom()
        } catch ( err ) {
            console.log( err )
        }

    }

    startSession = async ( payload ) => {
        //console.log(payload)
        try {
            const res = await this.api.startSession( payload )
            //console.log(res);

            if ( res["data"]["status"] === true ) {
                //notification.setNotification(true, "Starting session...")
                console.log( res["data"]["data"] )
                let baseUrl = btoa( res["data"]["data"] )

                localStorage.setItem( 'active_session', baseUrl )
                localStorage.setItem( 'poll_session', JSON.stringify( payload ) )
            } else {
                notification.setNotification( true, res["data"]["message"] || "Unable to start session..." )
            }
            return res["data"]
        } catch ( err ) {
            notification.setNotification( true, "Something went wrong. Try again!" )
            return { 'status': false, "message": "err" }
        }
    }

    joinSession = async ( payload ) => {
        try {
            const res = await this.api.joinSession( payload )
            //console.log(res);
            if ( res["data"]["status"] === true ) {
                //notification.setNotification(true, res["data"]["message"])
                let baseUrl = btoa( res["data"]["data"] )
                localStorage.setItem( 'active_session', baseUrl )
            } else {
                notification.setNotification( true, res["data"]["message"] )
            }
            return res["data"]
        } catch ( err ) {
            console.log( err )
            return { 'status': false }
        }
    }
    //
    joinSessionAsModerator = async ( payload ) => {
        try {
            const res = await this.api.joinSessionAsModerator( payload )
            //console.log(res);
            if ( res["data"]["status"] === true ) {
                //notification.setNotification(true, res["data"]["message"])
                let baseUrl = btoa( res["data"]["data"] )
                localStorage.setItem( 'active_session', baseUrl )
                localStorage.setItem( 'poll_session', JSON.stringify( payload ) )
            } else {
                notification.setNotification( true, res["data"]["message"] )
            }
            return res["data"]
        } catch ( err ) {
            console.log( err )
            return { 'status': false }
        }
    }

    endSession = async ( payload ) => {
        try {
            const res = await this.api.endSession( payload )
            //console.log(res);
            if ( res["data"]["status"] === true ) {
                notification.setNotification( true, res["data"]["message"] )
                // set stream
                this.streamDetails = { "is_stream": false, "stream_url": null, "stream_session": null }
                this.getMyActiveSessions()
                localStorage.removeItem( 'active_session' )
                localStorage.removeItem( 'poll_session' )
            } else {
                notification.setNotification( true, res["data"]["message"] )
            }
        } catch ( err ) {
            return false

        }
    }

    endSessionByAdmin = async ( payload ) => {
        try {
            const res = await this.api.endSession( payload )
            //console.log(res);
            if ( res["data"]["status"] === true ) {
                notification.setNotification( true, res["data"]["message"] )
                // set stream
                this.streamDetails = { "is_stream": false, "stream_url": null, "stream_session": null }
                return true
            } else {
                notification.setNotification( true, res["data"]["message"] )
                return false
            }
            // return res["data"];
        } catch ( err ) {
            return false

        }
    }

    getMyActiveSessions = async () => {
        try {
            const res = await this.api.getMySession()
            //console.log(`Active Session : `,res["data"]);
            if ( res["data"]["status"] === true ) {
                this.activeRoom = res["data"]["data"]
                // this.activeRoom = [{ "branch_name": "Computer Science", "subject_assignment_id": 712, "course_branch_assignment_id": null, "empID": "AU00076", "course_assignment_id": null, "institute_name_short": "AUZ", "current_sem": 5, "time_table_id": 8072, "batch_assignment_id": 74, "institute_id": 1, "current_year": null, "intervals": "9:50 AM - 10:40 AM", "branch_id": 1, "course_branch_short_name": null, "batch_short_name": "C2", "sTime": "09:50:00.0000000", "program_assignment_id": null, "presenter_name": "Vigneshwaran P ", "eTime": "22:40:00.0000000", "selected_date": "2025-09-08", "institute_name": "Acharya University", "course_short_name": null, "subject_id": 52, "startTime": "9:50 AM", "interval_type_id": 1, "subject_short_name": "CRYPTOGRAPHY AND NETWORK SECURITY", "endTime": "10:40 PM", "section_assignment_id": null, "record": false }]
            }
            return res["data"]
        } catch ( err ) {
            console.log( err )

        }
    }

    submitFeedback = async ( payload ) => {
        try {
            const res = await this.api.sendFeedback( payload )

            if ( res["data"]["status"] === false ) {

                if ( res["data"]["message"].constructor === Object && res["data"]["message"]["code"] === "23505" )
                    notification.setNotification( true, "You have already submitted feedback!" )
                else
                    notification.setNotification( true, res["data"]["message"] )
            } else {
                notification.setNotification( true, res["data"]["message"] )
            }
        } catch ( error ) {
            console.log( error )
        }
    }

    submitExam = async ( payload ) => {
        try {
            const res = await this.api.submitExamAnswers( payload )
            if ( res["data"]["status"] === false ) {
                notification.setNotification( true, res["data"]["message"] )
            } else {
                notification.setNotification( true, res["data"]["message"] )
            }
        } catch ( error ) {
            notification.setNotification( true, error )
        }
    }


    getExamTeacher = async () => {
        try {
            const res = await this.api.examFetch()
            this.exam = res["data"]["data"]
        } catch ( err ) {
            console.log( `err `, err )

        }
    }

    getExamSubmission = async ( id ) => {
        try {
            const res = await this.api.fetchExamSubmission( id )
            this.evaluate = res["data"]["data"]
        } catch ( err ) {
            console.log( `err `, err )

        }
    }

    downloadExamSubmission = async ( url ) => {
        let fname = url.split( "." )[url.split( "." ).length - 2] + "." + url.split( "." )[url.split( "." ).length - 1]
        try {
            const res = await this.api.downloadAssignment( url )
            fileDownload( res.data, fname )
        } catch ( err ) {

        }
    }

    assignScore = async ( payload ) => {
        try {
            const res = await this.api.assignScore( payload )
            notification.setNotification( true, res["data"]["message"] )
            this.getExamSubmission( payload.exam_id )
        } catch ( err ) {
            notification.setNotification( true, "Error! unable to assigning score" )

        }
    }


    getSessionClassAttendence = async ( payload ) => {
        if ( payload !== null ) {
            try {
                const res = await this.api.getSessionClassAttendence( payload )
                //console.log(`Attanadence Data`, res)
                if ( res["data"]["data"] === true ) {
                    notification.setNotification( true, res["data"]["message"] )
                    // alert( res["data"]["message"] )
                } else {
                    notification.setNotification( true, res["data"]["message"] )
                    // alert( res["data"]["message"] )
                }
            } catch ( err ) {
                console.log( err )
                // alert( "Something went wrong!" )
                notification.setNotification( true, "Something went wrong!" )
            }

        } else {
            // alert( "No session details!" )
            notification.setNotification( true, "No session details!" )
        }
    }
}

// decorate( RoomStore, {
//     room: observable,
//     exam: observable,
//     evaluate: observable,
//     loading: observable,
//     auditRoom: observable,
//     streamDetails: observable,
//     feedback: observable,
//     activeRoom: observable,
//     getRoom: computed,
//     getExam: computed,
//     getSubmission: computed,
//     getAuditRoom: computed,
//     getStreamDetails: computed,
//     getFeedback: computed,
//     getActiveRoom: computed,
//     fetchRoom: action,
//     fetchAuditRoom: action,
//     createRoom: action,
//     startSession: action,
//     fetchViewerAndPresenterRooms: action,
//     joinSession: action,
//     joinSessionAsModerator: action,
//     endSession: action,
//     endSessionByAdmin: action,
//     getMyActiveSessions: action,
//     setStreamDetails: action,
//     submitFeedback: action,
//     //getSessionClassAttendence:action,
//     resetStreamDetails: action,

// } )

const RoomStoreInstance = new RoomStore()

export default RoomStoreInstance

const RoomStoreContext = React.createContext()

export const RoomStoreProvider = ( { children, store } ) => {
    return (
        <RoomStoreContext.Provider value={store}>{children}</RoomStoreContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useRoomStore = () => React.useContext( RoomStoreContext )